<template>
  <div class="grid grid-cols-2 mb-[12px] last:mb-0">
    <span class="font-medium">{{ label }}</span>
    <p class="flex items-center justify-between mb-0">
      <span class="font-medium">:</span><span>{{ value | rupiah }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'FulfillmentResumeRow',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Informasi',
    },
    value: {
      type: Number,
      required: false,
      default: 0,
    },
  },
}
</script>
